import { render, staticRenderFns } from "./TokenManagementWalletCard.vue?vue&type=template&id=6175cf9d&scoped=true&lang=pug"
import script from "./TokenManagementWalletCard.vue?vue&type=script&lang=ts"
export * from "./TokenManagementWalletCard.vue?vue&type=script&lang=ts"
import style0 from "./TokenManagementWalletCard.vue?vue&type=style&index=0&id=6175cf9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175cf9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VAlert,VBtn,VCard,VCol,VIcon,VRow,VSwitch})
